// removed by extract-text-webpack-plugin
module.exports = {"modalform":"modalform__2ZYQP","submit":"submit__1KdMw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/ImportABPModal/styles.scss
// module id = 2206
// module chunks = 1